import Vue from 'vue';

const EventBus = new Vue();
// eslint-disable-next-line import/prefer-default-export
export { EventBus };
